/* eslint-disable no-unused-vars */
// eslint-disable-next-line max-len

import constants from "../constants/constants";

import cp_onboarding from "../assests/images/globalSetting/cp-onboarding.svg";

const { ROLES } = constants;
const { CP_ADMIN, HO_ADMIN, HUB_ADMIN } = ROLES;

export const dashboardMenuList = [
  // {
  //   icon: cashIcon,
  //   title: "Cash Booking",
  //   id: "cash-booking",
  //   additionalClass: "",
  //   route: "/cash-booking",
  //   role: [CP_ADMIN],
  // },
  // {
  //   icon: accountBookingIcon,
  //   title: "Account Booking",
  //   id: "account-booking",
  //   additionalClass: "",
  //   route: "/account",
  //   role: [CP_ADMIN],
  // },
  // {
  //   icon: viewBookingIcon,
  //   title: "View Booking",
  //   id: "view-booking",
  //   additionalClass: "",
  //   route: "/viewbooking",
  //   role: [CP_ADMIN],
  // },
  // {
  //   icon: middle_mile,
  //   title: "Last Mile Ops",
  //   id: "last-mile-operations",
  //   additionalClass: "",
  //   route: "/last-mile-operations",
  //   role: [CP_ADMIN],
  // },
  // {
  //   icon: master_setting,
  //   title: "Master Setting",
  //   id: "master-setting",
  //   additionalClass: "",
  //   route: "/masters",
  //   role: [HO_ADMIN],
  // },
  // {
  //   icon: message_alerts,
  //   title: "Message & Alert",
  //   id: "messageAlert",
  //   additionalClass: "",
  //   route: "/message-and-alerts",
  //   role: [HO_ADMIN],
  // },
  {
    id: "cp-onbording",
    icon: cp_onboarding,
    title: "CP Onboarding",
    route: "/cp-onbording",
    role: [HO_ADMIN],
  },
  // {
  //   icon: onboarding_setting,
  //   title: "Onboard Setting",
  //   id: "onboarding-settings",
  //   additionalClass: "",
  //   route: "/onboarding-settings",
  //   role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN],
  // },

  // {
  //   icon: audit,
  //   title: "Manifest List",
  //   id: "onboarding-settings",
  //   additionalClass: "",
  //   route: "/manifest-list",
  //   role: [CP_ADMIN],
  // },

  // {
  //   icon: middle_mile,
  //   title: "Hub Inbound",
  //   id: "middle-mile",
  //   additionalClass: "",
  //   route: "/middle-mile",
  //   role: [HUB_ADMIN],
  // },

  // {
  //   icon: hub_in_scan,
  //   title: "Hub Outbound",
  //   id: "hub-in-scan",
  //   additionalClass: "",
  //   route: "/hub-in-scan",
  //   role: [HUB_ADMIN],
  // },
  // {
  //   icon: configurationIcon,
  //   title: "Config Guide",
  //   id: "configuration-guide",
  //   additionalClass: "",
  //   route: "/configuration-guide",
  //   role: [HUB_ADMIN],
  // },
  // {
  //   icon: audit,
  //   title: "Audit",
  //   id: "view-audit",
  //   additionalClass: "",
  //   route: "/manifest-audit",
  //   role: [HUB_ADMIN],
  // },
  // {
  //   icon: product,
  //   title: "Products",
  //   id: "stationary-product",
  //   additionalClass: "",
  //   route: "/stationery",
  //   role: [HO_ADMIN],
  // },

  // {
  //   icon: product,
  //   title: "Request Products",
  //   id: "stationery",
  //   additionalClass: "",
  //   route: "/stationery",
  //   role: [CP_ADMIN, HUB_ADMIN],
  // },
  // {
  //   icon: my_order,
  //   title: "My Orders",
  //   id: "my-order",
  //   additionalClass: "",
  //   route: "/order-history",
  //   role: [CP_ADMIN, HUB_ADMIN],
  // },

  // {
  //   icon: Sorting,
  //   title: "Sorting Guide",
  //   id: "view-audit",
  //   additionalClass: "",
  //   route: "/sorting-guide",
  //   role: [HUB_ADMIN],
  // },

  // {
  //   icon: guide,
  //   title: "View Guides",
  //   id: "view-guide",
  //   additionalClass: "",
  //   route: "/guides",
  //   role: [HUB_ADMIN],
  // },

  // {
  //   icon: guide,
  //   title: "Inscan at Hub",
  //   id: "inscan-hub",
  //   additionalClass: "",
  //   route: "/in-scan-lcr",
  //   role: [HUB_ADMIN],
  // },

  // {
  //   icon: guide,
  //   title: "Outscan to CP",
  //   id: "out-scan-hub",
  //   additionalClass: "",
  //   route: "",
  //   role: [HUB_ADMIN],
  // },

  // {
  //   icon: reports,
  //   title: "Reports",
  //   id: "reports",
  //   additionalClass: "",
  //   route: "",
  //   role: [HO_ADMIN],
  // },
];
